<template>
  <v-sheet class="overflow-y-auto">
    <v-list
      v-if="isObject(inputsData)"
      id="simpleTreelist"
      class="text-caption"
      density="compact"
      nav
      :slim="true"
    >
      <template v-for="(value, key, idx) in inputsData">
        <v-list-group
          v-if="isObject(value)"
          :key="idx"
          :draggable="true"
          @dragstart="ondragActivation ? onDrag($event, key, value) : ''"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-code-json"
              class="text-caption"
              :title="key"
            >
              <template v-slot:prepend>
                <v-icon
                  icon="mdi-code-json"
                  color="blue-grey-darken-4"
                ></v-icon>
              </template>
            </v-list-item>
          </template>
          <SimpleTreeNode
            :jsonObj="value"
            :path="key"
            :ondragActivation="ondragActivation"
            @onDrag="onDrag"
          />
        </v-list-group>
        <v-list-item
          v-else
          :title="key"
          :subtitle="value"
          :key="`item-${idx}`"
          class="text-caption"
          :draggable="true"
          @dragstart="ondragActivation ? onDrag($event, key, value) : ''"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-location-exit" color="red-darken-2"></v-icon>
          </template>
        </v-list-item>
      </template>
    </v-list>
    <v-list
      v-else
      class="text-caption ml-n3"
      density="compact"
      nav
      :slim="true"
    >
      <v-list-item :title="inputsData" class="text-caption">
        <template v-slot:prepend>
          <v-icon icon="mdi-location-exit" color="red-darken-2"></v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
import { computed, inject } from "vue";
import SimpleTreeNode from "./SimpleTreeNode.vue";
import { drag, recognizeType } from "@/mixins/common-utils.js";
import jsonpath from "jsonpath";

export default {
  props: ["inputs", "ondragActivation"],
  components: {
    SimpleTreeNode,
  },
  setup(props) {
    const findNodeById = inject("findNodeById");

    let inputsData = computed(() => {
      return props.inputs;
    });
    //Checks if it is an object
    function isObject(obj) {
      if (obj === undefined) {
        return false;
      }
      const isJsonSerializable = JSON.parse(JSON.stringify(obj)) !== null;
      const isObjectOrArray = typeof obj === "object" || Array.isArray(obj);
      return isJsonSerializable && isObjectOrArray;
    }

    //Obtain the json-path for the key from the json object
    function findJsonPathForKey(jsonObj, key) {
      let result = jsonpath.query(jsonObj, `$..${key}`);
      if (result.length > 0) {
        return jsonpath.nodes(jsonObj, `$..${key}`)[0].path;
      } else {
        console.error("No matching keys found for key: ", key);
        return null;
      }
    }
    //Format value to the BE in {id_json:$...} for json input or {id} for others type
    function rewriteString(jpathNodes, valueType) {
      if (valueType != "text" || jpathNodes.length > 2) {
        let newStr = jpathNodes[1].startsWith("in_")
          ? `{${jpathNodes[1]}_json:$`
          : `{${jpathNodes[1]}:$`;
        for (let i = 2; i < jpathNodes.length; i++) {
          newStr += `.${jpathNodes[i]}`;
        }
        newStr += "}";
        return newStr;
      } else {
        return `{${jpathNodes[1]}}`;
      }
    }
    //Manages dragged item before to call drag method
    function onDrag(event, key, value) {
      const jpathValue = findJsonPathForKey(inputsData.value, key);
      const formattedValue = rewriteString(jpathValue, recognizeType(value));
      const arrayValues = JSON.stringify([formattedValue, value]);
      drag(event, arrayValues);
    }

    return { drag, onDrag, inputsData, isObject, findNodeById };
  },
};
</script>
<style scoped>
#simpleTreelist :deep(.v-list-item__prepend .v-icon) {
  margin-inline-end: 0px;
}
</style>
